import axios from 'axios';
import apiService from '../apiService';

export default async function recoverPassword(email = '', token = '', password = '', confirmPassword = '') {
  try {
    const _ret = await axios({
      url: `${apiService.getUrl().faceRecognition}loginAdmin/recoverPassword`,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        email: email,
        token: token,
        password: password,
        confirmPassword: confirmPassword,
      }
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return;
  } catch (error) {
    console.log('Error recoverPassword', error);
    throw error;
  }
}
